import { PostalDeliveryModel } from '$modules/personal/postal-delivery/models/postal-delivery-model';

export interface TrackStep {
  created_at: string;
  is_border: boolean;
  is_customs: boolean;
  place: string;
  event: string;
  place_index?: any;
  system?: string; // internal
  border_link?: string;
}

export interface CustomStep {
  evnt: string;
  evntDate: string;
  postOffice: string;
}

export class TrackInfo {
  public number: string;
  public comment?: string;
  public created_at?: string;
  public updated_at?: string;
  public id?: number;
  public user_id?: number;
  public last_event: TrackStep;
  public forseLoadSteps: boolean;
  public clarifyable: boolean;
  public redirectable: boolean;
  public show_order?: boolean;
  public order?: PostalDeliveryModel;
  public clarification_type: number;
  public creation_status: 'manually' | 'automatically' | 'mistaken';
  // manually - добавлено пользователем вручную, automatically - добавлено системой автоматически
  public steps?: TrackStep[];

  constructor(data?, forseLoadSteps?) {
    if (data) {
      if (forseLoadSteps) {
        this.forseLoadSteps = true;
      }
      Object.assign(this, data);
    }
  }

  public get lastEvent(): TrackStep {
    if (this.steps && this.steps.length) {
      return this.steps[0];
    } else if (this.last_event) {
      return this.last_event;
    } else {
      return {} as TrackStep;
    }
  }

  public update(data) {
    Object.assign(this, data);
  }
}

export class TracksInfo {
  public data: TrackInfo[];
  public uuid: string;
  public saved = false;

  constructor(data?: TracksInfo, forse?) {
    if (data) {
      data.data = data.data.map((el) => {
        return new TrackInfo(el, forse);
      });
      Object.assign(this, data);
    }
  }
}
